<script setup lang="ts">
defineProps<{
  src?: string
  alt?: string
  width?: string | number
  height?: string | number
  title?: string
}>()
</script>

<template>
  <NuxtImg
    v-if="src"
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    :title="title"
    format="webp"
    loading="lazy"
    sizes="sm:100vw md:768px lg:1024px"
    class="prose-img"
  />
</template>

<style scoped>
.prose-img {
  max-width: 100%;
  height: auto;
}
</style>
